(function() {
  
    /* Control Customizer Overlay on Product Page
    –––––––––––––––––––––––––––––––––––––––––––––––––– */
    if ($('#product-customizer').length) {
      // show customiser button
      $('#product-customizer-open').show();
      // store customiser loading state
      var customiserLoaded = false;
      // open customizer
      $('#product-customizer-open').click(function(e) {
        e.preventDefault();
        if(!customiserLoaded) {
          var cpb = document.createElement('script');
            cpb.setAttribute('src','https://cdn.thecustomproductbuilder.com/dist/latest/custom-product-builder.js');
            document.head.appendChild(cpb);
          customiserLoaded = true;
        }
        $('#product-customizer').addClass('active');
        trackCustomizerOpen();
      });
      // close customizer
      $('#product-customizer-close').click(function(e) {
        e.preventDefault();
        $('#product-customizer').removeClass('active');
      });
    }
    
    
    /* Track Open Customizer in GA and Facebook
    –––––––––––––––––––––––––––––––––––––––––––––––––– */
    function trackCustomizerOpen() {
      var productName = $('.product__title').html();
      // Google Analytics
      if (typeof ga == 'function') {
        ga('send', {
          hitType: 'event',
          eventCategory: 'Customizer App',
          eventAction: 'Clicked Customizer',
          eventLabel: productName
        });
      }
      // Facebook
      /*
      fbq('track', 'CustomizeProduct', {
          "source": "shopify",
          "content_name": productName
      });
      */
    }

    /* Fix selecting colour options on iOS
    –––––––––––––––––––––––––––––––––––––––––––––––––– */
    $('#product-builder').on('touchstart', 'div.cpb-option cpb-option-type-color', function(e){
      e.preventDefault();
      $(this).click();
      return false;
    });

    $('#product-builder').on('touchstart', '.cpb-option-type-color span', function(e){
      e.preventDefault();
      $(this).parent().click();
      return false;
    });

    /* Customizer Changes
    –––––––––––––––––––––––––––––––––––––––––––––––––– */
    if ($('#product-builder').length) {
      // wait for customizer to load
      var isCustomizerLoaded = function() {
        if ($('.cpb-add-to-cart-button span').length > 0) {
          customizerAdditionalJS();
        } else {
          window.requestAnimationFrame(isCustomizerLoaded);
        }   
      };
      isCustomizerLoaded();
      // when customizer has loaded...
      function customizerAdditionalJS() {
        // add breadcrumbs (if exist)
        if ($('#customizerBreadcrumb').length && $('#breadcrumb').length ) {
          $('#customizerBreadcrumb').html($('#breadcrumb').html());
        }
        // open all customizer options (as closed by default)
        $('.cpb-category-title span').not('.cpb-category.active .cpb-category-title span').click();
        // add price
        $('.cpb-panel-wrapper').first().prepend('<p id="customPrice">' + $('.cpb-product-price').html() + '</p>');
        // add title
        $('.cpb-panel-wrapper').first().prepend('<h1 id="customTitle">' + $('#product-builder').data('title') + '</h1>');
        // update price when custom options change
        var targetNode = $('.cpb-product-actions-first')[0];
        var config = { attributes: false, childList: true, subtree: true };
        var callback = function(mutationsList, observer) {
          var priceChanged = false;
          for (var mutation of mutationsList) {
            if (mutation.type === 'childList') {
              if (mutation.addedNodes.length > 0) {
                priceChanged = true;
              }
            }
          }
          if (priceChanged) {
            $('#customPrice').html($('.cpb-product-price span').html());
          }
        };
        var observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
      }
    }
    
  })()
  